import { render, staticRenderFns } from "./VmLoginButton.vue?vue&type=template&id=090a63f4&scoped=true&"
import script from "./VmLoginButton.vue?vue&type=script&lang=js&"
export * from "./VmLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./VmLoginButton.vue?vue&type=style&index=0&id=090a63f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a63f4",
  null
  
)

export default component.exports